import { ref } from 'vue';

import { administrationApiSdk } from '../sdk/administrationClient.js';

import { defineCollectionStore } from './collectionStore.js';

/**
 * Dealership Operations — a dealer family's brand.
 *
 * The Auction Operation's shape without the knockouts: an Operation bars people
 * from the houses it runs, and a dealer group runs none.
 */
export const useDealershipOperationsStore = defineCollectionStore({
    id: 'administration-dealership-operations',
    client: administrationApiSdk.dealershipOperations,
    extend({ client, attempt, holdCurrent }) {
        const dealerships = ref([]);
        const dealershipCount = ref(0);

        async function loadDealerships(id, pagination) {
            const attempted = await attempt(function () {
                return client.listDealerships(id, pagination);
            });
            if (attempted.ok === false) {
                return false;
            }
            dealerships.value = attempted.value.documents;
            dealershipCount.value = attempted.value.meta.totalCount;
            return true;
        }

        return {
            dealerships,
            dealershipCount,
            loadDealerships,

            setLegalCompany: (id, companyId) => holdCurrent(() => client.setLegalCompany(id, companyId)),
            setManagementCompany: (id, companyId) => holdCurrent(() => client.setManagementCompany(id, companyId)),
            setBillingCompany: (id, companyId, subscriptionId) => holdCurrent(
                () => client.setBillingCompany(id, companyId, subscriptionId)
            ),
            setPolicy: (id, policyName, policy) => holdCurrent(() => client.setPolicy(id, policyName, policy)),
            clearPolicy: (id, policyName) => holdCurrent(() => client.clearPolicy(id, policyName))
        };
    }
});

export default useDealershipOperationsStore;
